import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Surface } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.colors.tertiaryContainer,
      borderRadius: 20,
      marginHorizontal: 16,
      marginVertical: 8,
      overflow: 'hidden'
    },
    contentWrapper: { paddingHorizontal: 16, paddingVertical: 16 }
  });

export const LoadingRefChatMessage: FC = () => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <Surface style={styles.container} elevation={0}>
      <View style={styles.contentWrapper}>
        <ActivityIndicator size={80} />
      </View>
    </Surface>
  );
};
